export default [
    {
        id: 1,
        name_ca: 'Balcó',
        name_en: 'Balcony',
        name_es: 'Balcón',
    },
    {
        id: 2,
        name_ca: 'Jardí',
        name_en: 'Garden',
        name_es: 'Jardín',
    },
    {
        id: 3,
        name_ca: 'Terrassa',
        name_en: 'Terrace',
        name_es: 'Terraza',
    },
    {
        id: 4,
        name_ca: 'Pati',
        name_en: 'Courtyard',
        name_es: 'Patio',
    },
    {
        id: 5,
        name_ca: 'Altres',
        name_en: 'Others',
        name_es: 'Otros',
    }

]



// WEBPACK FOOTER //
// ./src/options/uncovered_outdoor_types.js